<template>
  <section class="text-gray-700 text-gray-800 font-display">
    <slot></slot>
  </section>
</template>

<script>
export default {}
</script>

<style>
</style>
